var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsLightNotAllowed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4853 26L19.364 35.1213C18.7474 35.7379 17.9293 36.03 17.1217 35.9976C17.0813 35.9992 17.0408 36 17 36H13C11.3431 36 10 34.6569 10 33C10 31.3431 11.3431 30 13 30H16L25.0662 20.9338C25.3233 20.6767 25.6154 20.4761 25.9272 20.3318C26.3386 20.1197 26.8053 20 27.3 20H31C32.6568 20 34 21.3431 34 23C34 24.6569 32.6568 26 31 26H28.4853Z",
    fill: "#222222",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 38C33.7614 38 36 35.7614 36 33C36 30.2386 33.7614 28 31 28C28.2386 28 26 30.2386 26 33C26 35.7614 28.2386 38 31 38ZM28.4343 34.5556C28.1587 34.102 28 33.5695 28 33C28 31.3431 29.3431 30 31 30C31.5695 30 32.102 30.1587 32.5556 30.4343L28.4343 34.5556ZM29.4444 35.5657C29.898 35.8413 30.4305 36 31 36C32.6569 36 34 34.6569 34 33C34 32.4305 33.8413 31.898 33.5657 31.4444L29.4444 35.5657Z",
    fill: "#38ac68",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsLightNotAllowed);
export default __webpack_public_path__ + "static/media/es-light-not-allowed.0d1196d6202ef8f4f0753d8713ebd20c.svg";
export { ForwardRef as ReactComponent };